/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendServiceDbPingResponseDto } from '../../models/backend-service-db-ping-response-dto';

export interface ServiceDbPingDebugServiceDbGet$Params {}

export function serviceDbPingDebugServiceDbGet(
  http: HttpClient,
  rootUrl: string,
  params?: ServiceDbPingDebugServiceDbGet$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendServiceDbPingResponseDto>> {
  const rb = new RequestBuilder(rootUrl, serviceDbPingDebugServiceDbGet.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendServiceDbPingResponseDto>;
    }),
  );
}

serviceDbPingDebugServiceDbGet.PATH = '/debug/service-db';
